import * as React from "react";
import { DeliveryIndicator } from "@grandvisionhq/shipping";
import { useCartSettings } from "../../../../../../context/CartSettings/context/CartSettings/context.js";
import { useCart } from "../../../../../../context/Cart/context/Cart/context.js";
const DeliveryIndicatorContainer = ({ lineItemId }) => {
  const settings = useCartSettings();
  const { cart } = useCart();
  const lineItem = cart?.lineItems.filter(
    (lineItem2) => lineItem2.id === lineItemId
  )[0];
  if (!lineItem) {
    return null;
  }
  const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory([lineItem]);
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      view: "short",
      availability: lineItem.availability ? [lineItem.availability] : [],
      deliveryResolver
    }
  );
};
export {
  DeliveryIndicatorContainer
};
//# sourceMappingURL=DeliveryIndicatorContainer.js.map
